import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-16 bg-white" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12" }
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7"
}
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7"
}
const _hoisted_6 = { class: "relative overflow-hidden h-52" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "w-full h-full bg-neutral-100 flex items-center justify-center"
}
const _hoisted_9 = { class: "absolute top-3 left-3 bg-primary-500 text-white text-xs font-semibold px-3 py-1 rounded-full" }
const _hoisted_10 = { class: "absolute bottom-3 left-3 bg-white text-neutral-800 text-sm font-bold px-3 py-1.5 rounded-lg shadow" }
const _hoisted_11 = { class: "p-5" }
const _hoisted_12 = { class: "text-base font-bold text-neutral-800 mb-1 group-hover:text-primary-500 transition-colors line-clamp-1" }
const _hoisted_13 = { class: "flex items-center gap-1.5 text-sm text-neutral-400 mb-4" }
const _hoisted_14 = { class: "flex items-center justify-between text-xs text-neutral-500 mb-4" }
const _hoisted_15 = { class: "flex items-center gap-1.5" }
const _hoisted_16 = { class: "flex items-center gap-1.5" }
const _hoisted_17 = { class: "flex items-center gap-1.5" }
const _hoisted_18 = { class: "flex items-center gap-1.5" }
const _hoisted_19 = {
  key: 2,
  class: "text-center py-16 text-neutral-400 text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", null, [
          _createElementVNode("p", { class: "text-primary-500 text-sm font-semibold uppercase tracking-widest mb-2" }, "Hand-picked for you"),
          _createElementVNode("h2", { class: "text-3xl md:text-4xl font-bold text-neutral-800" }, " Featured Properties ")
        ], -1)),
        _createVNode(_component_router_link, {
          to: "/properties",
          class: "inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors group"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" View All Properties ", -1),
            _createElementVNode("svg", {
              class: "w-4 h-4 group-hover:translate-x-1 transition-transform",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M17 8l4 4m0 0l-4 4m4-4H3"
              })
            ], -1)
          ]))]),
          _: 1
        })
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "bg-white rounded-2xl border border-neutral-100 shadow-sm overflow-hidden animate-pulse"
              }, [...(_cache[2] || (_cache[2] = [
                _createStaticVNode("<div class=\"h-52 bg-neutral-200\" data-v-0a7b106c></div><div class=\"p-5 space-y-3\" data-v-0a7b106c><div class=\"h-4 bg-neutral-200 rounded w-3/4\" data-v-0a7b106c></div><div class=\"h-3 bg-neutral-100 rounded w-1/2\" data-v-0a7b106c></div><div class=\"h-3 bg-neutral-100 rounded w-full\" data-v-0a7b106c></div><div class=\"h-9 bg-neutral-100 rounded-xl mt-2\" data-v-0a7b106c></div></div>", 2)
              ]))])
            }), 64))
          ]))
        : (_ctx.featuredProperties.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featuredProperties, (property) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: property.id,
                  class: "group bg-white rounded-2xl border border-neutral-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    (property.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: property.image,
                          alt: property.title,
                          class: "w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        }, null, 8, _hoisted_7))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("svg", {
                            class: "w-12 h-12 text-neutral-300",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                            })
                          ], -1)
                        ]))])),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" }, null, -1)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(property.type), 1),
                    _createElementVNode("span", _hoisted_10, " RWF " + _toDisplayString(property.price.toLocaleString()), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("button", { class: "absolute top-3 right-3 w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow transition-colors" }, [
                      _createElementVNode("svg", {
                        class: "w-4 h-4 text-neutral-500 hover:text-red-500 transition-colors",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                        })
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h3", _hoisted_12, _toDisplayString(property.title), 1),
                    _createElementVNode("p", _hoisted_13, [
                      _cache[6] || (_cache[6] = _createElementVNode("svg", {
                        class: "w-4 h-4 flex-shrink-0",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        }),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(property.location), 1)
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "border-t border-neutral-100 mb-4" }, null, -1)),
                    _createElementVNode("div", _hoisted_14, [
                      (property.type === 'Plot')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex items-center gap-1.5 text-emerald-600" }, [
                              _createElementVNode("svg", {
                                class: "w-4 h-4",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                                })
                              ]),
                              _createElementVNode("span", { class: "font-semibold" }, "Land Plot")
                            ], -1)),
                            _createElementVNode("div", _hoisted_15, [
                              _cache[7] || (_cache[7] = _createElementVNode("svg", {
                                class: "w-4 h-4 text-primary-400",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                                })
                              ], -1)),
                              _createElementVNode("span", null, _toDisplayString(property.size ? property.size + ' m²' : '—'), 1)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_16, [
                              _cache[9] || (_cache[9] = _createElementVNode("svg", {
                                class: "w-4 h-4 text-primary-400",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                })
                              ], -1)),
                              _createElementVNode("span", null, _toDisplayString(property.bedrooms) + " Beds", 1)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _cache[10] || (_cache[10] = _createElementVNode("svg", {
                                class: "w-4 h-4 text-primary-400",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M8 7h8m-8 5h8m-4-9v14"
                                })
                              ], -1)),
                              _createElementVNode("span", null, _toDisplayString(property.bathrooms) + " Baths", 1)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _cache[11] || (_cache[11] = _createElementVNode("svg", {
                                class: "w-4 h-4 text-primary-400",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                                })
                              ], -1)),
                              _createElementVNode("span", null, _toDisplayString(property.size ? property.size + ' m²' : '—'), 1)
                            ])
                          ], 64))
                    ]),
                    _createVNode(_component_router_link, {
                      to: `/property/${property.id}`,
                      class: "block w-full text-center py-2.5 rounded-xl text-sm font-semibold text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-200"
                    }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode(" View Details ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, " No featured properties available at the moment. "))
    ])
  ]))
}